import React, { useState } from "react";
import Nav from "../Nav";
import Footer from "../Footer";
import PubHomeData from "../PublHomeData";

export default function Product() {
  const [products, setProducts] = useState(PubHomeData); // State for product data
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [originalProducts] = useState(PubHomeData); // Preserve the original product data

  // Handle search functionality
  const handleSearch = () => {
    const filteredProducts = originalProducts.filter((product) =>
      product.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setProducts(filteredProducts);
  };

  // Handle refresh functionality
  const handleRefresh = () => {
    setProducts(originalProducts);
    setSearchQuery(""); // Clear the search input
  };

  return (
    <div>
      <Nav />

      {/* Search and Refresh Controls */}
      <div className="search-container" style={{ margin: "20px", textAlign: "center" }}>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search by product name"
          className="form-control"
          style={{ display: "inline-block", width: "300px", marginRight: "10px" }}
        />
        <button onClick={handleSearch} className="btn btn-primary" style={{ marginRight: "10px" }}>
          Search
        </button>
        <button onClick={handleRefresh} className="btn btn-secondary">
          Refresh
        </button>
      </div>

      <div className="allProducts">
        <div style={{ margin: "20px", overflowX: "auto" }}>
          <table className="table table-bordered">
            <thead>
              <tr className="table-light">
                <th>S.No.</th> {/* Added Serial Number Column */}
                <th>Name</th>
                <th>Price</th>
                <th>Weight</th>
                <th>Category</th>
                <th>Out of Stock</th>
                <th>On Home</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr key={index}>
                  <td>{index + 1}</td> {/* Serial Number */}
                  <td>{product.name}</td>
                  <td>{product.price}</td>
                  <td>{product.weight}</td>
                  <td>{product.category}</td>
                  <td>{product.outOfStock ? "Yes" : "No"}</td>
                  <td>{product.onHome ? "Yes" : "No"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Footer />
    </div>
  );
}
